import React, { useEffect } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-white font-sans text-stone-900" data-id="element-266">
      <nav className="bg-white border-b border-stone-100 py-4 sticky top-0 z-50" data-id="element-267">
        <div className="container mx-auto px-4 flex justify-between items-center" data-id="element-268">
          <span className="font-serif font-bold text-xl text-stone-900 tracking-tight" data-id="element-269">
            Mil Hojas <span className="text-amber-600" data-id="element-270">Pro</span>
          </span>
        </div>
      </nav>

      <main data-id="element-271">
        <HeroSection data-id="element-272" />
        <ProblemSection data-id="element-273" />
        <SolutionSection data-id="element-274" />
        <BenefitsSection data-id="element-275" />
        <TestimonialsSection data-id="element-276" />
        <OfferSection data-id="element-277" />
      </main>

      <Footer data-id="element-278" />
    </div>;
}